import React from 'react';
import PropTypes from 'prop-types';
import styles from './DoneBtn.module.scss';

const DoneBtn = ({visible, disabled, clickHandler, withIcon, inlineStyles, children}) => {

    if (!visible) {
        return null;
    }

    const classes = [styles.doneBtnContainer];
    if (disabled) classes.push(styles.disabled);

    return (
        <div className={classes.join(' ')} style={inlineStyles} onClick={clickHandler}>
            {withIcon && <div className={styles.icon}>&times;</div>}
            {children}
        </div>
    );
};

DoneBtn.propTypes = {
    visible: PropTypes.bool,
    disabled: PropTypes.bool,
    withIcon: PropTypes.bool,
    inlineStyles: PropTypes.object,
    clickHandler: PropTypes.func,
};

DoneBtn.defaultProps = {
    visible: true,
    disabled: false,
    withIcon: false,
    inlineStyles: {},
    clickHandler: () => null,
};

export default DoneBtn;
